import { useForm } from 'react-typed-form';

import { Api, useApiFormSubmit } from '../../../api';
import { Button, Modal, ModalFooter, Stack } from '../../../components';
import { useSelectedCompany } from '../../../contexts';
import {
  FieldText,
  FieldTextRequired,
  createFormValidator,
} from '../../../form';

type Props = {
  invalidate: () => unknown;
  onClose: () => void;
};

export default function NewIdeaModal({ invalidate, onClose }: Props) {
  const company = useSelectedCompany();

  const form = useForm<Api.WishlistIdea.W_Create>({
    defaultValues: {
      company: `/companies/${company.id}`,
      title: '',
      body: '',
      uploads: [],
    },
    validator: createFormValidator({
      title: { strictPresence: { message: '^Please enter a title' } },
    }),
    onSubmit: useApiFormSubmit('POST', '/wishlist-ideas', {
      onSuccess: () => {
        onClose();
        invalidate();
      },
    }),
  });

  return (
    <Modal title="New idea" onClose={onClose} fullScreenOnMobile>
      <Stack padH={1.5} padV={1.5} gap={1.5}>
        <FieldTextRequired
          field={form.getField('title')}
          label="Title"
          placeholder="What's the idea?"
        />
        <FieldText
          field={form.getField('body')}
          label="Description"
          placeholder="Add some detail (optional)"
          multiline
        />
      </Stack>

      <ModalFooter>
        <Button
          label="Cancel"
          variant="text"
          colorScheme="black"
          onClick={onClose}
        />
        <Button
          type="submit"
          label="Add idea"
          disabled={form.isLoading}
          onClick={form.handleSubmit}
        />
      </ModalFooter>
    </Modal>
  );
}
